/**
 * Business Intelligence Dashboard Page
 * Main page for business intelligence and predictive analytics
 */

import React from 'react';
import BusinessIntelligenceDashboard from '../../components/analytics/BusinessIntelligenceDashboard';

const BusinessIntelligenceDashboardPage = () => {
  return (
    <div>
      <BusinessIntelligenceDashboard />
    </div>
  );
};

export default BusinessIntelligenceDashboardPage;
